$.fn.resizer = function (callback) {
	const unbind = arguments[0] === "unbind"
	if (!unbind && !$.isFunction(callback)) {
		throw new Error(
			'Invalid argument, it need to a function or string "unbind".'
		)
	}
	if (unbind) {
		callback = $.isFunction(arguments[1]) ? arguments[1] : null
	}
	return this.each(function () {
		const $this = $(this)
		let iframe
		let callbacks
		if (unbind) {
			callbacks = $this.data('callbacks')
			if (callback && callbacks) {
				callbacks.remove(callback)
				if (!callbacks.has()) {
					callbacks = null
				}
			} else {
				callbacks = null
			}
			if (!callbacks) {
				$this.removeData('callbacks')
				if (window.ResizeObserver) {
                    const observer = $this.data('observer')
                    if (observer) {
						observer.unobserve(this)
						$this.removeData('observer')
					}
				} else {
					iframe = $this.find('> iframe')
					if (iframe.length) {
						// just in case of memory leaks in IE
						$(iframe[0].contentWindow).off('resize').remove()
						iframe.remove()
					}
				}
			}
		} else if ($this.data('callbacks')) {
			$(this).data('callbacks').add(callback)
		} else {
			callbacks = $.Callbacks()
			callbacks.add(callback)
			$this.data('callbacks', callbacks)
			let resizer
			let first = true
			if (window.ResizeObserver) {
				resizer = new ResizeObserver(function () {
					if (!first) {
						const callbacks = $this.data('callbacks')
						callbacks.fire()
					}
					first = false
				})
				resizer.observe(this)
				$this.data('observer', resizer)
			} else {
				this.css('position', 'relative')
				const style = {
					position: 'absolute',
					left: 0,
					top: 0,
					right: 0,
					bottom: 0,
					overflow: 'hidden',
					'z-index': -1,
					visibility: 'hidden',
					height: '100%',
					border: 'none',
					padding: 0,
					width: '100%'
				}
				iframe = $('<iframe/>').css(style).appendTo(this)[0]

				$(iframe.contentWindow).on('resize', function () {
					callbacks.fire()
				})
			}
		}
	})
}
const window_events = $.Callbacks()

$.event.special.resize = {
	setup: function (data, namespaces, eventHandle) {
		if (this === window) {
			window.addEventListener('resize', eventHandle)
			$(window).data('handler', eventHandle)
		}
	},
	teardown: function () {
		if (this === window) {
			const eventHandle = $(window).data('handler')
			window.removeEventListener('resize', eventHandle)
		}
	},
	add: function (handleObj) {
		if (this === window) {
			window_events.add(handleObj.handler)
		} else {
			$(this).resizer(handleObj.handler)
		}
	},
	remove: function (handleObj) {
		if (this === window) {
			if (!handleObj.handler) {
				window_events.empty()
			} else {
				window_events.remove(handleObj.handler)
			}
		} else {
			$(this).resizer('unbind', handleObj.handler)
		}
	},
	handle: function (event, data) {
		window_events.fireWith(window, event, data)
	}
}
